import { FiEdit2 } from "react-icons/fi";
import { Action, ActionProps } from "../action";
import { forwardRef } from "react";

export const Edit = forwardRef<HTMLButtonElement, ActionProps>(
  (props: ActionProps, ref) => {
    return <Action {...props} ref={ref} Icon={FiEdit2} variant="default" />;
  }
);
